<template>
	<div class="modal" id="text-copy-modal" tabindex="-1" role="dialog" aria-labelledby="myModalOptionLabel">
		<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
			<div class="modal-content" style="margin-bottom:5rem;">
				<div class="modal-body">
					&nbsp;テキストをクリップボードにコピーしました！
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { nanoid } from 'nanoid'
import $ from "jquery";
window.$ = window.jQuery = $;

export default {
	props: {
	},
	data: () => ({
		
	}),
	
	created() {
		
	},
	
	methods: {
		eventStop(e) {
			  e.preventDefault();
			  e.stopPropagation();
			  e.stopImmediatePropagation();
		},
	},
	
	mounted() {
		const _self = this;
		
		$("#text-copy-modal").on("hidden.bs.modal", function(e) {
		
		});
		
		$("#text-copy-modal").on("show.bs.modal", function(e) {
			const $modal = $("#text-copy-modal");
			setTimeout(() => { // メッセージを非表示にする
				$modal.modal("hide");
			}, 1000)
		});

	}
}
</script>
<style>
</style>